import { h } from './dom';
import {
  siteName,
  breadcrumb,
  hero,
  copy
} from './data';

function hamburgerIcon(): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '16');
  svg.setAttribute('height', '16');
  svg.setAttribute('viewBox', '0 0 16 16');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  for (const [x, y] of [
    [1, 1],
    [9, 1],
    [1, 9],
    [9, 9]
  ]) {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('x', String(x));
    rect.setAttribute('y', String(y));
    rect.setAttribute('width', '6');
    rect.setAttribute('height', '6');
    rect.setAttribute('fill', 'currentColor');
    svg.append(rect);
  }
  return svg;
}

function renderHeader(): HTMLElement {
  return h('header', { class: 'cds--header', role: 'banner' }, [
    h('div', { class: 'cds--header__left' }, [
      h('div', { class: 'shell-header__hamburger' }, [hamburgerIcon()]),
      h('a', { class: 'cds--header__name', href: '#' }, [siteName])
    ]),
    h('div', { class: 'cds--header__right' }, [
      h('button', { type: 'button', class: 'theme-toggle', 'data-theme-toggle': '' }, ['Dark']),
      h('a', { href: '/crm-mock.html', class: 'open-crm-link' }, [copy.header.crmLink])
    ])
  ]);
}

function renderBreadcrumb(): HTMLElement {
  const nodes: (string | Node)[] = [];
  breadcrumb.forEach((crumb, i) => {
    const isLast = i === breadcrumb.length - 1;
    nodes.push(
      isLast
        ? h('span', { class: 'current' }, [crumb.label])
        : h('a', { href: crumb.href }, [crumb.label])
    );
    if (!isLast) nodes.push(h('span', { class: 'sep' }, ['/']));
  });
  return h('nav', { class: 'cds--breadcrumb', 'aria-label': 'Breadcrumb' }, nodes);
}

function renderHeroTitle(): HTMLElement {
  const [lead, ...rest] = hero.title.split(' ');
  return h('h1', { class: 'hero__title' }, [
    rest.length ? `${lead} ` : lead,
    ...(rest.length ? [h('strong', {}, [rest.join(' ')])] : [])
  ]);
}

function renderHero(): HTMLElement {
  return h('div', { class: 'hero' }, [
    h('div', { class: 'hero__content' }, [
      h('p', { class: 'hero__eyebrow' }, [hero.eyebrow]),
      renderHeroTitle(),
      h('p', { class: 'hero__desc' }, [hero.description]),
      h('div', { class: 'hero__actions' }, [
        h('a', { href: '#', class: 'cds--btn cds--btn--primary' }, [
          `${copy.hero.primaryAction} `,
          h('span', { class: 'cds--btn__icon' }, ['\u2192'])
        ]),
        h('a', { href: '#', class: 'cds--btn cds--btn--tertiary' }, [copy.hero.secondaryAction])
      ])
    ])
  ]);
}

function renderFooter(): HTMLElement {
  const year = String(new Date().getFullYear());
  const copyright = copy.footer.copyright
    .replace('{year}', year)
    .replace('{version}', __APP_VERSION__);
  return h('footer', {}, [
    h('div', { class: 'footer-bottom' }, [
      h('span', {}, [copyright])
    ])
  ]);
}

export function renderApp(root: HTMLElement): void {
  document.title = `${hero.title} | ${siteName}`;
  root.append(
    renderHeader(),
    renderBreadcrumb(),
    renderHero(),
    renderFooter()
  );
}
